module.exports = __webpack_public_path__ + "static/media/jdIcon.18bc2e22.svg";